
<!--  -->
<template>
  <div class="comContent">
    <Tabs @tab-click="handleClick" style="padding:0 24px" :tabsList="tabsList" :activeName.sync="activeName"></Tabs>
    <div class="topHeader">
      <div style="width:calc(100% - 230px)">
        <el-form ref="formTool" :model="formTool" :inline="true" style="display:flex;">

          <!-- 未展开 -->
          <template v-if="!expanded">
            <div class="item big" style="display: flex;justify-content: center;">
              <el-input style="width: 300px;margin-right: 16px;" v-model="formTool.keyWords" size="small"
                placeholder="服务单号/订单编号/商品名称/客户名称" />
            </div>
          </template>

          <!-- 展开 -->
          <template v-else>
            <div class="item big" style="display: flex;justify-content: center;">
              <el-form-item prop="code" size="small">
                <el-input v-model="formTool.code" clearable placeholder="服务单号" />
              </el-form-item>
              <el-form-item prop="orderCode" size="small">
                <el-input v-model="formTool.orderCode" clearable placeholder="订单编号" />
              </el-form-item>
              <el-form-item prop="goodsName" size="small">
                <el-input v-model="formTool.goodsName" clearable placeholder="商品名称" />
              </el-form-item>
              <el-form-item prop="shopName" size="small">
                <el-input v-model="formTool.shopName" clearable placeholder="客户名称" />
              </el-form-item>
              <el-form-item prop="date" size="small">
                <el-date-picker v-model="formTool.date" type="daterange" value-format="yyyy-MM-dd" range-separator="-"
                  start-placeholder="开始日期" end-placeholder="结束日期" />
              </el-form-item>
              <el-form-item prop="content" size="small">
                <el-select v-model="formTool.applyForType" clearable placeholder="申请类型">
                  <el-option v-for="li in options" :key="li.value" :label="li.label" :value="li.value" />
                </el-select>
              </el-form-item>
            </div>
          </template>
        </el-form>
      </div>
      <div style="width:220px">
        <MyButton type="primary" text="查询" @click="getList(1)" />
        <MyButton type="" text="重置" @click="reset()" />
        <el-button type="text" size="small" @click="handleExpand()">
          {{ expanded ? "收起" : "展开" }}
          <i :class="{
            'el-icon-arrow-up': expanded,
            'el-icon-arrow-down': !expanded,
            'el-icon--right': true,
          }"></i>
        </el-button>
      </div>
    </div>

    <div class="center">
      <MyTable v-if="tableData.length > 0" :table-data="tableData" :index="index" :selection="selection" :page="page"
        :operation="operation" :table-option.sync="tableOption" @page-change="getList">
        <template slot="amount" slot-scope="scope">
          <span>
            ￥{{ scope.row.amount }}
          </span>
        </template>
        <template slot="caozuo" slot-scope="scope">
          <el-link type="primary" :underline="false" @click="detail(scope.row)">
            详情
          </el-link>
        </template>
      </MyTable>
      <el-empty v-else style="height:100%" description="暂无数据" />
    </div>
  </div>
</template>

<script>
import MyButton from '@/components/myButton'
import MyTable from '@/components/myTable'
import Tabs from '@/components/Tabs'
import { buttonView } from '@/api/externalSalesRule/index'
import { aftersalePageForOps } from '@/api/afterSales/serviceSheet'
export default {
  components: { MyButton, MyTable, Tabs },
  data() {
    return {
      expanded: '',
      afterSalesControl: '', // 售后控制
      rowId: '',
      options: [
        {
          label: '退货退款',
          value: 'THTK'
        },
        {
          label: '退款',
          value: 'TK'
        },
        {
          label: '商家退款',
          value: 'SJTK'
        },
      ],

      dialogVisible: false,
      textarea: '',

      imageList: [],
      tabsList: [ // tabs 传的值
        {
          name: 'first',
          label: '全部售后单',
          value: 0,
        },
        {
          name: 'CHECKING',
          label: '审核中',
          value: 0,
        },
        {
          name: 'WAIT_EVIDENCE',
          label: '待举证',
          value: 0,
        },
        {
          name: 'WAIT_SALE',
          label: '待退货',
          value: 0,
        },
        {
          name: 'SALEING',
          label: '退货中',
          value: 0,
        },
        {
          name: 'REFUNDING',
          label: '退款中',
          value: 0,
        },
        {
          name: 'FINISH',
          label: '退款成功',
          value: 0,
        },
        {
          name: 'CANCEL',
          label: '退款关闭',
          value: 0,
        },
        {
          name: 'REJECT',
          label: '驳回',
          value: 0,
        },
        {
          name: 'WAIT_ENTER',
          label: '待确款',
          value: 0,
        }
      ],
      activeName: 'first', // tabs 传的值
      formTool: {
        keyWords: '',
        date: [],
        goodsName: '',
        shopName: '',
        orderCode: '',
        code: '',
        applyForType: ''
      },
      operation: false,
      selection: false,
      index: false,
      tableData: [
      ],
      tableOption: [],
      tableOptionFrist: [
        { label: '商品名称', prop: 'goodsName' },
        { label: '客户名称', prop: 'payShopName' }, // 这里表示自定义列, slot: true
        { label: '申请时间', prop: 'orderTime' },
        { label: '客户联系方式', prop: 'contactsPhone' },
        // { label: '订单编号', prop: 'orderCode' },
        { label: '数量', prop: 'qty' },
        { label: '应退金额', prop: 'amount', slot: true },
        // { label: '售后发起方', prop: 'type' },
        { label: '申请类型', prop: 'type' },
        { label: '操作', prop: 'caozuo', slot: true, width: '200px', align: 'center' }
      ],
      tableOptionProof: [
        { label: '商品名称', prop: 'goodsName' },
        { label: '客户名称', prop: 'payShopName' }, // 这里表示自定义列, slot: true
        { label: '申请时间', prop: 'orderTime' },
        { label: '客户联系方式', prop: 'contactsPhone' },
        { label: '数量', prop: 'qty' },
        { label: '应退金额', prop: 'amount', slot: true },
        { label: '申请类型', prop: 'type' },
        // { label: '剩余时间', prop: 'countDownTime', slot: true, width: '140px', align: 'left' },
        { label: '操作', prop: 'caozuo', slot: true, width: '200px', align: 'center' }
      ],
      tableOptionAfter: [
        { label: '商品名称', prop: 'goodsName' },
        { label: '客户名称', prop: 'payShopName' }, // 这里表示自定义列, slot: true
        { label: '申请时间', prop: 'orderTime' },
        { label: '客户联系方式', prop: 'contactsPhone' },
        { label: '数量', prop: 'qty' },
        { label: '应退金额', prop: 'amount', slot: true },
        { label: '申请类型', prop: 'type' },
        // {
        //   label: '处理倒计时', prop: 'countDownTimeAfter', slot: true, width: '140px', align: 'left'
        // },
        { label: '操作', prop: 'caozuo', slot: true, width: '200px', align: 'center' }
      ],
      page: {
        total: 10,
        current: 1,
        size: 10
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.tableOption = this.tableOptionFrist;
    this.buttonView()
    this.getList()
  },
  mounted() {

  },
  methods: {
    handleExpand() {
      this.expanded = !this.expanded;
    },
    // 根据商户查询数据权限判断前端按钮展示
    buttonView() {
      buttonView().then(res => {
        if (res) {
          this.afterSalesControl = res.afterSalesControl
        }
      })
    },
    // 查询
    getList(current) {
      if (current) {
        this.page.current = current
      }
      let params = {
        ...this.formTool,
        type: 'payee',
        status: this.activeName == 'first' ? '' : this.activeName,
        size: this.page.size,
        current: this.page.current,
        startOrderTime: '',
        endOrderTime: ''
      }
      if (this.expanded) {
        params.keyWords = "";
      } else {
        params.keyWords = this.formTool.keyWords;
      }
      params.startOrderTime = params.date ? params.date[0] : ''
      params.endOrderTime = params.date ? params.date[1] : ''
      const shopId = this.$route.query.shopId
      if (!shopId) {
        return
      }
      params.shopId = shopId
      aftersalePageForOps(params).then(res => {
        if (res.code == 0) {
          this.tabsList[1].value = res.data.checkingQty
          this.tabsList[2].value = res.data.waitEvidenceQty //待举证
          this.tabsList[3].value = res.data.waitSaleQty   //待退货
          this.tabsList[4].value = res.data.saleQty     //退货中
          this.tabsList[5].value = res.data.refundingQty  //退款中
          this.tabsList[8].value = res.data.rejectQty    //驳回
          this.tabsList[9].value = res.data.waitEnterQty  //待确款
          this.tableData = res.data.page.records         //表格数据
          this.page.total = res.data.page.total          //总条数
        }
      })
    },
    // 重置查询条件
    reset() {
      // this.formTool.storeName = ''
      this.$refs.formTool.resetFields()
      this.formTool = { date: null, invoiceNo: '', content: '' }
      this.page.current = 1
      this.getList()
    },
    // 点击tab
    handleClick() {
      this.tableOption = [];
      if (this.activeName == 'WAIT_EVIDENCE' || this.activeName == 'REJECT') {
        this.$set(this,'tableOption',this.tableOptionProof)
      } else if (this.activeName == 'CHECKING' || this.activeName == 'SALEING' || this.activeName == 'REFUNDING' || this.activeName == 'WAIT_SALE') { 
        this.$set(this,'tableOption',this.tableOptionAfter)
      } else { 
        this.$set(this,'tableOption',this.tableOptionFrist)
      }
      this.getList(1)
      this.$forceUpdate();

    },
    // 查看详情
    detail(row) {
      this.$router.push({ path: '/ordercenter/ordercenter-afterSalesDocumentDetail', query: { afterSaleId: row.id } })
    },
  }
}
</script>
<style lang='scss' scoped>
.comContent {
  padding: 0px;
}

.expand {
  &_box {
    padding: 20px 30px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  &_li {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 45%;
    margin-right: 3%;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 10px;
    word-break: break-all;

    strong {
      margin-right: 10px;
      font-weight: 400;
      color: #000;
    }

    span {
      color: #666;
    }

    &_more {
      position: relative;
    }

    &_link {
      color: #f5222d;

      &:hover {
        color: #3db4b9;
      }
    }

    &_img {
      width: 100px;
      height: 100px;
    }
  }
}

.center {
  margin: 0 24px;
  height: calc(100% - 170px);
}

.myTabs {
  height: 56px;
  padding: 0 24px;
  border-bottom: 1px solid #f5f5f5 !important;
}

.topHeader {
  padding: 0 24px;
  display: flex;
  text-align: left;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  line-height: 56px;
}

.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0px !important;
}

::v-deep .el-dialog__footer {
  border-top: 1px #f5f5f5 solid;
  padding-top: 15px;
}

::v-deep .tooltip__popper {
  max-width: 200px !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
}

::v-deep .el-statistic {
  text-align: left;
}
</style>
